import {Card, CardContent, styled} from '@mui/material';

const StyledCard = styled(Card)`
	width: 25%;
	max-width: 285px;

	${({theme}) => theme.breakpoints.between('sm', 'lg')} {
		width: 33%;
	}

	${({theme}) => theme.breakpoints.down('sm')} {
		width: 50%;
	}
`;

const StyledCardContent = styled(CardContent)`
	display: flex;
	flex-direction: column;
	gap: 16px;
	align-items: center;
	height: 100%;
`;

const StyledImage = styled('img')`
	width: 100%;
	object-fit: contain;
	height: auto;
	max-width: 196px;
	max-height: 181px;
`;

export {StyledCard, StyledCardContent, StyledImage};
